module.exports = __webpack_public_path__ + "static/media/prasoon.efea2f75.png";